if (typeof window !== 'undefined') {
	const ga = (window.ga =
		window.ga || ((...args) => (ga.q = ga.q || []).push(args)));

	setTimeout(() => {
		ga('create', 'UA-155995063-1', 'auto');
		ga('set', 'transport', 'beacon');
		// Pageview is being sent in route change handler in app.js
		// ga('send', 'pageview');
	});
}
